import { useEffect, useRef } from 'react';

const ClickOutside = ({ onClickOutside, children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        onClickOutside(event);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [containerRef, onClickOutside]);

  return <div ref={containerRef}>{children}</div>;
};

export default ClickOutside;
